import React, { useEffect, useRef } from 'react'
import styles from '../../styles'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { IntlShape, useIntl } from 'react-intl'
import classNames from 'classnames'
import Link from '../../components/link/Link'
import { useMediaQuery } from 'react-responsive'
import fetchFactory from '../../utils/fetchFactory'
import { PageModel } from '../../types/footer/footer_model'
import { useHistory } from 'react-router'
import links from '../../enums/linksEnum'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../reducers'
import errorCatcher from '../../utils/errorCatcher'
import { saveFooter } from '../reducers/footer/actions'
import { ClassValue } from 'classnames/types'
import languagesEnum from "../../enums/languagesEnum";

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	footerContainer: {
		width: '100%',
		display: 'flex',
		backgroundColor: 'white',
		paddingTop: '3%',
		paddingBottom: 100
	},
	logoContainerLargeScreen: {
		'& img': {
			height: 93,
			margin: '0 17px'
		}
	},
	logoContainerSmallScreen: {
		paddingLeft: '8%',

		'& img': {
			height: 80
		}
	},
	optionContainer: {
		display: 'flex'
	},
	optionDivLargeScreen: {
		marginRight: 40,
		'&:first-child': {
			marginLeft: '55px'
		}
	},
	optionContainerSmallScreen: {
		justifyContent: 'space-around',
		paddingLeft: '8%',
		columnGap: '8%',
		columnCount: 2
	},
	optionContainerMobileScreen: {
		paddingLeft: '8%'
	},
	optionDivSmallScreen: {
		marginBottom: '2%',
		display: 'inline-block',
		width: '-webkit-fill-available'
	}

}))

const ID_FOOTER = 'get_footer'

const AppFooter: React.FC = () => {
	const classes = useStyle()
	const intl: IntlShape = useIntl()
	const oldLanguage = useRef(intl.locale)
	const history = useHistory()
	const footer: PageModel[] = useSelector((state: RootState) => state.footer)
	const dispatch = useDispatch()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)
	const isDesktopScreen = useMediaQuery(
		{
			query: '(min-width: 770px)'
		}
	)

	const footerContainerClass: ClassValue = classNames(
		classes.footerContainer,
		isLargeScreen ? classes.alignCenter : classes.flexColumn
	)

	const logoContainerClass: ClassValue = classNames(
		'col-xs-12 col-md-2',
		isLargeScreen ? classes.logoContainerLargeScreen : classes.logoContainerSmallScreen
	)

	const optionContainer = classNames(
		isLargeScreen ? 'col-md-10' : 'col-xs-12',
		{
			[classes.optionContainer]: isLargeScreen,
			[classes.optionContainerSmallScreen]: !isLargeScreen && isDesktopScreen,
			[classes.optionContainerMobileScreen]: !isDesktopScreen
		}
	)

	const optionDiv = classNames(
		isLargeScreen ? classes.optionDivLargeScreen : classes.optionDivSmallScreen
	)

	useEffect(() => {
		if (footer.length === 0 || oldLanguage.current !== intl.locale) {
			fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/information/getFooterPages?language=${intl.locale}&activityLine=${process.env.REACT_APP_TARGET}`)
				.then(
					(data: any) => {
						dispatch(
							saveFooter(data)
						)
					}
				)
				.catch(
					(error: any) => dispatch(
						errorCatcher(error, ID_FOOTER)
					)
				)
				.finally(
					() => oldLanguage.current = intl.locale
				)
		}
	}, [dispatch, footer.length, intl.locale])

	const seeDetailsFooterPage = (id: string) => {
		history.push(`${links.footer}/${id}`)
	}

	return (
		<div className={footerContainerClass}>
			<div className={logoContainerClass}>
				<img
					src={intl.locale === languagesEnum.fr ? "img/youFirstGecina.png" : "img/EN_youFirstGecina.png"}
					alt="Logo Youfirst Gecina"
					id="logo YF Gecina"
				/>
			</div>

			<div className={optionContainer}>
				{
					footer.map(
						(pageFooter) => (
							<div
								className={optionDiv}
								key={pageFooter.id}
							>
								<Link
									color="colorBlue"
									textStyle="text4"
									hasChevron={false}
									onClick={() => seeDetailsFooterPage(pageFooter.id)}
								>
									{pageFooter.title}
								</Link>
							</div>
						)
					)
				}
			</div>
		</div>
	)
}

export default AppFooter
